<template>
  <div class="infor-geral">
    <div class="categorias subtitle">
      <p>Informações Gerais</p>
    </div>

    <div class="items">
      <div class="items-row-infor-gerais-infor-gerais bd-right">
        <div class="item-title"><p>Cliente</p></div>
        <p>{{ dataInforGeral.CLIENTE }}</p>
      </div>

      <div class="items-row-infor-gerais bd-right">
        <div class="item-title">Nº Nota Fiscal</div>
        <div>{{ dataInforGeral.NOTA_FISCAL || "Não Aplicável" }}</div>
      </div>
      <div class="items-row-infor-gerais bd-right">
        <div class="item-title">Emissão</div>
        <div v-if="VerifyDateInEmetionNote(dataInforGeral.EMISSAO)">
          {{ ReformDate(dataInforGeral.EMISSAO) }}
        </div>
        <div v-else>N/A</div>
      </div>

      <!-- <div class="bd-right bd-top">
        <div class="item-title">Número Molde</div>
        <div>{{ dataInforGeral.MOLDE }}</div>
      </div> -->

      <div class="bd-right">
        <div class="item-title">Cod. Molde do Cliente</div>
        <div>{{ dataInforGeral.CODIGO_MOLDE }}</div>
      </div>
      <div>
        <div class="item-title">Fabricante do Molde</div>
        <div>{{ dataInforGeral.FABRICANTE_MOLDE }}</div>
      </div>
    </div>
    <div class="items bd-top">
      <div class="items-row-infor-gerais bd-right">
        <div class="item-title">Data Chegada do Molde</div>
        <div>{{ ReformDate(dataInforGeral.DT_CHEGADA_MOLDE) }}</div>
      </div>
      <div class="items-row-infor-gerais bd-right">
        <div class="item-title">Data Abertura do Molde</div>
        <div>{{ ReformDate(dataInforGeral.DT_ABERTURA_MOLDE) }}</div>
      </div>
      <div class="items-row-infor-gerais">
        <div class="item-title">Data de Try-Out</div>
        <div>{{ ReformDate(dataInforGeral.DT_TRYOUT_MOLDE) }}</div>
      </div>
    </div>
  </div>
</template>

<script scoped>
import dayjs from "dayjs";
export default {
  props: {
    dataInforGeral: Object,
  },

  methods: {
    ReformDate(date) {
      const data = dayjs(date).add(1, "day").format("DD/MM/YYYY");

      return data;
    },

    VerifyDateInEmetionNote(date) {
      if (date < new Date("01-01-1990")) {
        return false;
      }

      return true;
    },
  },
};
</script>

<style scoped>
.items-row-infor-gerais {
  width: 100%;
  height: auto;
  background: var(--white);
  font-size: 12px;
  align-items: center;
  justify-content: center;
}

.bd-top {
  border-top: 1px solid #636363;
}
</style>
